export default class JobFunction {
  id: number;
  label: string;
  labelNl: string;
}

export const getJobFunctionLabel = (jobFunction: JobFunction, locale: string) => {
  if (!jobFunction) return '';
  switch (locale) {
    case 'nl':
      return jobFunction.labelNl || jobFunction.label;
    case 'fr':
      return jobFunction.label;
    default:
      return jobFunction.label;
  }
};
